import { defineStore } from 'pinia';

export const useAiChatSettingsStore = defineStore('ai-chat-settings', () =>
{
    const aiChatSettings = ref<ChatSettingsModel>(defaultAiChatSettings());

    function loadAiChatSettings()
    {
        AiChatService.getSettings()
            .then((data) =>
            {
                aiChatSettings.value = data;
            })
            .catch((error) =>
            {
                // eslint-disable-next-line no-console
                console.log(error);
            });
    }

    async function reload()
    {
        await loadAiChatSettings();
    }

    reload();

    return { aiChatSettings, reload };
});
